<template>
  <VueDatePicker utc="preserve" timezone="Europe/Moscow" :locale="$i18n.locale" class="q-py-sm" :style="'width: 150px; min-width: 150px; max-width: 150px;'" :teleport="true"
    v-model="theModel" :enable-time-picker="false"
    :clearable="false" :required="true" :format="formatDate" :text-input="textInputOptions" />
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import {
  ParameterInstance,
} from "../../../models/interfaces/parameters/parameter-models";

/**
 * A component for displaying DateValue type
 */

@Component({
  name: "ParameterDateField",
  emits: ["update:modelValue", "update:nested"]
})
export default class ParameterDateField extends Vue {
  @Prop({ default: {} as ParameterInstance })
  modelValue!: ParameterInstance;
  @Prop({ type: Boolean, default: false }) editable!: boolean;
  // прокидывается InlineDescriptor; используется в Фазе Date, объявлен чтобы не падал в DOM-атрибуты
  @Prop({ default: undefined }) nestedIndex!: number | undefined;

  get textInputOptions() {
    return {
      enterSubmit: true,
      tabSubmit: true,
      openMenu: 'toggle',
      rangeSeparator: '-',
      selectOnFocus: false,
      format: 'dd.MM.yyyy'
    }
  }

  formatDate (date: Date): string {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${year}`;
  }

  get theModel(): Date | null {
    return !this.modelValue.DateValue ? null : this.modelValue.DateValue
  }

  set theModel(newValue: Date | null) {
    // VueDatePicker может повторно вызвать сеттер на ре-рендере/нормализации с тем же моментом
    // времени; getTime абсолютен и не зависит от таймзоны, поэтому сравниваем по нему.
    const prev = this.modelValue.DateValue ? new Date(this.modelValue.DateValue).getTime() : null;
    const next = newValue ? new Date(newValue).getTime() : null;
    this.modelValue.DateValue = newValue;
    this.$emit('update:modelValue', this.modelValue)
    // значение фактически не менялось - не поднимаем персист, иначе лишний повторный PATCH даты
    if (prev === next) return;
    // тот же конвейер, что у чекбокса: поднимаем событие до root, чтобы сработал персист.
    // eventKind=2: изменение значения. Свежую дату кладём в sectionText как ISO - источник правды для root.
    this.$emit('update:nested', {
      fieldKey: null,
      sectionText: newValue ? new Date(newValue).toISOString() : '',
      eventKind: 2,
      nestedIndex: this.nestedIndex,
      opts: {
        InstanceId: this.modelValue.Id,
        ValueType: this.modelValue.ValueType,
        ValueSet: this.modelValue.ValueSet,
        TemplateId: this.modelValue.TemplateId,
        selectedId: this.modelValue.SelectedValue?.Id,
      },
    })
  }
}
</script>
<style scoped>
</style>
